export default __webpack_public_path__ + "media/zurb/img/ecommerce/product_page-dfe2e45ee81f832cfc94032914240d61.png";